<template>
    <div class="container">
        <div class="search" style="display:flex">
            <el-form ref="formRef" style="flex:1" :inline="true" :model="form" class="demo-form-inline" size="mini">
                <el-form-item label="商户CODE：" prop="partner_code">
                    <el-input v-model.trim="form.partner_code" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item label="状态：" prop="status">
                    <el-select v-model="form.status" placeholder="">
                        <el-option label="全部" :value="-1"></el-option>
                        <el-option label="待审核" :value="0"></el-option>
                        <el-option label="审核通过" :value="1"></el-option>
                        <el-option label="审核拒绝" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 16px;" class="btnClass"
                        @click="onSearch">搜索</el-button>
                    <el-button type="text" class="textBtn" style="padding-bottom: 0px;vertical-align: bottom;"
                        @click="resetForm(formRef)">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-table :data="list" size="mini">
            <el-table-column label="商户CODE" width="100">
                <template v-slot="scope">
                    <span>{{ scope.row.partner_code }}</span>
                </template>
            </el-table-column>
            <el-table-column label="申请编号" width="160">
                <template v-slot="scope">
                    <span>{{ scope.row.settlement_no }}</span>
                </template>
            </el-table-column>
            <el-table-column label="设备型号" width="120">
                <template v-slot="scope">
                    <span>{{ scope.row.model_code }}</span>
                </template>
            </el-table-column>
            <el-table-column label="申请设备数量" width="120">
                <template v-slot="scope">
                    <span>{{ scope.row.device_count }}</span>
                </template>
            </el-table-column>
            <el-table-column label="每个设备激活单价" width="140">
                <template v-slot="scope">
                    <span>{{ scope.row.single_commission }}</span>
                </template>
            </el-table-column>
            <el-table-column label="申请金额">
                <template v-slot="scope">
                    <span>{{ scope.row.amount_cny }}</span>
                </template>
            </el-table-column>
            <el-table-column label="生产票据">
                <template v-slot="scope">
                    <el-button type="primary" size="mini" @click="handlePreview(scope.row.file_uri)">预览</el-button>
                </template>
            </el-table-column>
            <el-table-column label="状态" width="80">
                <template v-slot="scope">
                    <span>{{ scope.row.status === 0 ? '待审核' : scope.row.status === 1 ? '审核通过' : scope.row.status === 2 ?
                        '审核拒绝' :
                        "" }}</span>
                </template>
            </el-table-column>
            <el-table-column label="审核结果描述" width="120">
                <template v-slot="scope">
                    <span>{{ scope.row.status_msg }}</span>
                </template>
            </el-table-column>
            <el-table-column label="申请人" width="120">
                <template v-slot="scope">
                    <span>{{ scope.row.apply_adminer }}</span>
                </template>
            </el-table-column>
            <el-table-column label="申请备注">
                <template v-slot="scope">
                    <span>{{ scope.row.apply_remark }}</span>
                </template>
            </el-table-column>
            <el-table-column label="申请时间" width="110">
                <template v-slot="scope">
                    <span>{{
                        scope.row.create_time ? dayjs
                            .unix(scope.row.create_time)
                            .format('YYYY-MM-DD HH:mm:ss') : ''
                    }}</span>
                </template>
            </el-table-column>
            <el-table-column label="审核人" width="80">
                <template v-slot="scope">
                    <span>{{ scope.row.auditor }}</span>
                </template>
            </el-table-column>
            <el-table-column label="审核时间" width="110">
                <template v-slot="scope">
                    <span>{{
                        scope.row.audit_time ? dayjs
                            .unix(scope.row.audit_time)
                            .format('YYYY-MM-DD HH:mm:ss') : ''
                    }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="80">
                <template v-slot="scope">
                    <el-button type="primary" size="mini" class="btnClass" @click="handleAudit(scope.row)"
                        v-if="scope.row.status === 0">审核</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:currentPage="pagination.page"
            :page-size="pagination.limit" layout="total, prev, pager, next" :total="pagination.total" background>
        </el-pagination>
        <el-dialog v-model="auditVisible" title="审核" width="570px">
            <el-form ref="auditFormRef" :model="auditForm" size="small" label-width="110px" :rules="auditRules">
                <el-form-item label="审核状态：" prop="status">
                    <el-select v-model="auditForm.status" placeholder="">
                        <el-option label="通过" :value="1"></el-option>
                        <el-option label="拒绝" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="理由：" prop="status_msg">
                    <el-input v-model="auditForm.status_msg" autocomplete="off" />
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button size="small" @click="auditVisible = false">取消</el-button>
                    <el-button type="primary" size="small" @click="audit(auditFormRef)">
                        确认
                    </el-button>
                </div>
            </template>
        </el-dialog>
        <!-- 文件预览弹窗 -->
        <FilePreview v-model:modelValue="showFilePreview" :file-uri="currentFileUri" />
    </div>
</template>

<script>
import { onMounted, reactive, ref, toRaw, watch } from 'vue'
import { ElMessage } from 'element-plus'
import util from '../../../util/util'
import api from '../../../axios/api'
import dayjs from 'dayjs'
import FilePreview from './components/FilePreview.vue'

export default {
    components: {
        FilePreview
    },
    setup() {
        const form = reactive({
            partner_code: '',
            status: -1
        })
        const pagination = reactive({
            page: 1,
            limit: 16,
            total: 0
        })
        const formRef = ref()
        const list = ref([])
        const auditVisible = ref(false)
        const auditForm = reactive({
            settlement_no: '',
            status: 1,
            status_msg: ''
        })
        const auditFormRef = ref()
        const auditRules = reactive({
            status: [
                { required: true, message: '请选择审核状态', trigger: 'change' }
            ],
            status_msg: [
                { required: true, message: '请输入理由', trigger: 'blur' }
            ],
        })
        const showFilePreview = ref(false)
        const currentFileUri = ref('')

        const handleCurrentChange = (val) => {
            pagination.page = val
            onSearch()
        }

        const onSearch = async () => {
            const res = await api.SalesPartnerSettlementDeviceFactoryApplyList({
                ...toRaw(form),
                page: pagination.page,
                limit: pagination.limit
            })
            if (res.data.code === 200) {
                const { data, page_info } = res.data.data
                list.value = data
                pagination.total = page_info.total
            } else {
                ElMessage.error('查询失败: ' + res.msg)
            }
        }

        const handleAudit = (row) => {
            auditForm.settlement_no = row.settlement_no
            auditVisible.value = true
        }

        const resetForm = (formEl) => {
            if (!formEl) return
            formEl.resetFields()
            onSearch()
        }

        const audit = async (formEl) => {
            if (!formEl) return
            await formEl.validate(async (valid, fields) => {
                if (valid) {
                    try {
                        const res = await api.SalesPartnerSettlementDeviceFactoryApplyAudit(toRaw(auditForm))
                        if (res.data.code === 200) {
                            ElMessage.success('审核成功')
                            auditVisible.value = false
                            onSearch()
                        } else {
                            ElMessage.error('审核失败: ' + res.data.msg)
                        }
                    } catch (error) {
                        console.log(error)
                    }
                } else {
                    console.log('error submit!', fields)
                }
            })
        }

        const handlePreview = (fileUri) => {
            if (!fileUri) {
                ElMessage.warning("该记录没有关联的文件")
                return
            }
            currentFileUri.value = fileUri
            showFilePreview.value = true
            console.log('设置showFilePreview为true')
        }

        // 侦测审核表单状态，设置auditRules
        watch(() => auditForm.status, (newVal) => {
            if (newVal === 2) {
                auditRules.status_msg = [
                    { required: true, message: '请输入理由', trigger: 'blur' }
                ]
            } else {
                auditRules.status_msg = []
            }
        }, { immediate: true })

        onMounted(() => {
            onSearch()
        })

        return {
            form,
            onSearch,
            list,
            formRef,
            pagination,
            handleCurrentChange,
            resetForm,
            util,
            dayjs,
            auditVisible,
            auditForm,
            auditFormRef,
            handleAudit,
            auditRules,
            audit,
            showFilePreview,
            currentFileUri,
            handlePreview
        }
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
	font-family: 'Manrope';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	.search {
		background: #F0F2F5;
		padding-top: 16px;
		margin-bottom: 24px;
	}
	.el-form {
		::v-deep(.el-form-item__label) {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
            opacity: 0.8;
			padding-right: 0px;
		}
		.el-form-item {
			margin-left: 24px;
		}
	}
	.btnClass {
		color: #FFF;
		background-color: #FB6D07;
		border-color: #FB6D07;
	}
	.textBtn {
		color: #FB6D07;
	}
	::v-deep(thead) {
		font-family: 'Manrope';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #000;
		opacity: 0.8;
		th {
			font-weight: 400;
			background-color: #F0F2F5;
		}
	}
  ::v-deep(tbody) {
    tr {
      font-family: 'Manrope';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      opacity: 0.8;
    }
  }

}
</style>
